import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { TodoEntryModel } from '../../models/todo-planner/todo-entry.model';
import {
  setSingleTodoPlannerEntry,
  setTodoPlannerEntries,
  todoPlannerEntryAdded,
  todoPlannerEntryDeleted,
  todoPlannerEntryUpdated,
  todoPlannerMultipleEntriesUpdated,
} from './todo-planner.actions';

export interface TodoEntriesState extends EntityState<TodoEntryModel> {}

export const todoEntriesAdapter: EntityAdapter<TodoEntryModel> =
  createEntityAdapter<TodoEntryModel>();
const initialState: TodoEntriesState = todoEntriesAdapter.getInitialState();

export const todoEntriesReducer = createReducer(
  initialState,
  on(
    setTodoPlannerEntries,
    (state, { payload }): TodoEntriesState => todoEntriesAdapter.setAll(payload, state),
  ),
  on(
    setSingleTodoPlannerEntry,
    (state, { payload }): TodoEntriesState => todoEntriesAdapter.setOne(payload, state),
  ),
  on(
    todoPlannerEntryAdded,
    (state, { payload }): TodoEntriesState =>
      todoEntriesAdapter.addOne(payload.todoEntryModel, state),
  ),
  on(
    todoPlannerEntryUpdated,
    (state, { payload }): TodoEntriesState =>
      todoEntriesAdapter.upsertOne(payload.todoEntryModel, state),
  ),
  on(
    todoPlannerMultipleEntriesUpdated,
    (state, { payload }): TodoEntriesState =>
      todoEntriesAdapter.upsertMany(payload.todoEntryModels, state),
  ),
  on(
    todoPlannerEntryDeleted,
    (state, { payload }): TodoEntriesState =>
      todoEntriesAdapter.removeOne(
        typeof payload === 'number' ? payload : payload.todoEntryModel.id,
        state,
      ),
  ),
);
